import { useState, useEffect } from 'react'
import { evalApiClient } from '@/lib/api/eval.client'
import type { EvalCostEstimateResponse } from '@super/shared-types'

interface UseEvalCostEstimateResult {
  estimate: EvalCostEstimateResponse | null
  isFetching: boolean
}

export function useEvalCostEstimate(opts: {
  companyId?: string
  promptType?: string
}): UseEvalCostEstimateResult {
  const { companyId, promptType } = opts
  const [estimate, setEstimate] = useState<EvalCostEstimateResponse | null>(
    null,
  )
  const [isFetching, setIsFetching] = useState(false)

  useEffect(() => {
    let cancelled = false
    setIsFetching(true)

    evalApiClient
      .estimateCost({ companyId, promptType })
      .then(response => {
        if (!cancelled) setEstimate(response)
      })
      .finally(() => {
        if (!cancelled) setIsFetching(false)
      })

    return () => {
      cancelled = true
    }
  }, [companyId, promptType])

  return { estimate, isFetching }
}
